import {writable} from 'svelte/store'

export const charmManager = writable(null)
